import Vue from 'vue';
import { gsap } from 'gsap';
import { Datetime } from 'vue-datetime';

import Errors from '../classes/Errors';
import Redactor from '../vendor/redactor.js';

Vue.component('add-event-form-component', {
    props: {
        eventTypes: {
            type: Array
        },

        eventLanguages: {
            type: Array
        },

        organizations: {
            type: Array
        },

        locations: {
            type: Array
        },
    },

    components: {
        datetime: Datetime,
    },

    data() {
        return {
            eventName: null,
            eventTypeString: null,
            eventTypeValue: null,
            eventLanguageString: null,
            eventLanguageValue: null,
            locationString: null,
            locationValue: null,
            organizationString: null,
            organizationValue: null,
            startDateTime: null,
            endDateTime: null,
            doorsOpen: null,
            
            eventHeaderImage: null,
            freeEvent: false,
            eventTicketPrice: null,
            eventPreviousTicketPrice: null,
            eventTicketLink: null,
            eventImage: null,
            eventShortDescription: null,
            eventDescription: null,
            eventEnglishDescription: null,
            eventProgrammeDescription: null,
            organizationValue: null,
            eventPartnersDescription: null,
            eventContactName: null,
            eventContactEmail: null,

            agreeTerms: null,

            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            activeStep: 1,
            generalError: null,
        };
    },

    mounted() {
        Redactor('#redactor1', {
            formatting: ['p'],
            buttons: ['format', 'bold', 'italic', 'link'],
        });

        Redactor('#redactor2', {
            formatting: ['p'],
            buttons: ['format', 'bold', 'italic', 'link'],
        });

        Redactor('#redactor3', {
            formatting: ['p'],
            buttons: ['format', 'bold', 'italic', 'lists'],
        });

        this.eventPartnersDescription = Redactor('#redactor4', {
            formatting: ['p'],
            buttons: ['format', 'bold', 'italic', 'lists'],
        });
    },

    watch: {
        freeEvent() {
            if (this.freeEvent) {
                // Safe price for when mistakenly clicked on free event checkbox
                this.eventPreviousTicketPrice = this.eventTicketPrice;
                this.eventTicketPrice = null;
            }


            if (!this.freeEvent) {
                // Put back the saved value if there is any
                this.eventTicketPrice = this.eventPreviousTicketPrice;
            }
        },

        eventTicketPrice() {
            if (this.eventTicketPrice.includes(',')) {
                this.eventTicketPrice = this.eventTicketPrice.replace(',', '.');
            }
        }
    },

    // computed: {
    //     firstStepValid() {
    //         return this.eventName && this.eventTypeValue && this.eventLanguageValue && this.eventHeaderImage && this.startDateTime;
    //     },

    //     secondStepValid() {
    //         return this.eventShortDescription && this.eventPartnersDescription && this.eventContactName && this.eventContactEmail && this.agreeTerms;
    //     }
    // },

    methods: {
        selectEventType(event, value, title) {
            const dropdownOptions = event.currentTarget.parentNode;
            const dropdownCurrent = dropdownOptions.previousElementSibling;

            this.eventTypeValue = value;
            this.eventTypeString = title;

            dropdownCurrent.classList.remove('collapsed');
            dropdownOptions.classList.remove('open');
            gsap.to(dropdownOptions, { height: '100%', opacity: 0 });
        },

        selectEventLanguage(event, value, title) {
            const dropdownOptions = event.currentTarget.parentNode;
            const dropdownCurrent = dropdownOptions.previousElementSibling;

            this.eventLanguageValue = value;
            this.eventLanguageString = title;

            dropdownCurrent.classList.remove('collapsed');
            dropdownOptions.classList.remove('open');
            gsap.to(dropdownOptions, { height: '100%', opacity: 0 });
        },

        selectLocation(event, value, title) {
            const dropdownOptions = event.currentTarget.parentNode;
            const dropdownCurrent = dropdownOptions.previousElementSibling;

            this.locationValue = value;
            this.locationString = title;

            dropdownCurrent.classList.remove('collapsed');
            dropdownOptions.classList.remove('open');
            gsap.to(dropdownOptions, { height: '100%', opacity: 0 });
        },

        selectOrganization(event, isMaker = false, id, title, description) {
            const dropdownOptions = event.currentTarget.parentNode;
            const dropdownCurrent = dropdownOptions.previousElementSibling;

            this.organizationValue = id;
            this.organizationString = title;

            this.eventPartnersDescription.source.setCode('');
            if (isMaker) {
                this.eventPartnersDescription.source.setCode(description);
            }

            dropdownCurrent.classList.remove('collapsed');
            dropdownOptions.classList.remove('open');
            gsap.to(dropdownOptions, { height: '100%', opacity: 0 });
        },

        toggleDropdown(event) {
            const dropdownCurrent = event.currentTarget;
            const dropdownOptions = dropdownCurrent.nextElementSibling;

            if (dropdownCurrent.classList.contains('collapsed')) {
                dropdownCurrent.classList.remove('collapsed');
                dropdownOptions.classList.remove('open');
                gsap.to(dropdownOptions, { height: '100%', opacity: 0 });

                return;
            }

            dropdownCurrent.classList.add('collapsed');
            dropdownOptions.classList.add('open');
            gsap.to(dropdownOptions, { height: 'auto', opacity: 1 });
        },

        async onSubmit(event) {
            this.generalError = null;
            const form = event.currentTarget;

            this.organizationValue === 'none' ? null : this.organizationValue;

            if (this.submitting || this.formCompleted) {
                return;
            }

            this.submitting = true;

            const formData = new FormData(form);

            formData.append(window.csrfTokenName, window.csrfTokenValue);
            formData.append('sectionUid', "510ea76d-7e47-4e6c-b5d1-bb2278a4b2ed");
            formData.append('authorUsername', "programmapartner");

            axios.post('/actions/guest-entries/save', formData)
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (response.data.errors) {
                        this.errors.clear();
                        this.errors.record(response.data.errors);
                        console.log(this.errors);
                        console.log(response.data.errors);

                        this.$nextTick(() => {
                            this.errors.scrollToFirst();
                        });

                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();

                    // window.location = this.$refs.redirectUrl.value;
                    // this.scrollToTop();
                })
                .catch((error) => {
                    this.generalError = 'Er is iets misgegaan. Probeer het later opnieuw.';

                    this.submitting = false;
                    
                    this.errors.clear();
                    this.errors.record(error.response.data.errors);

                    this.$nextTick(() => {
                        this.errors.scrollToFirst();
                    });
                });
        },

        onHeaderImageUpload(imageId) {
            this.eventHeaderImage = imageId;
        },

        onImageUpload(imageId) {
            this.eventImage = imageId;
        },
    },
});
